<template>
  <div :class="`filters-block ${isOpen ? 'active' : ''}`" >
    <p :class="`title ${isOpen ? 'active' : ''}`"
        @click.prevent="isOpen=!isOpen"
    >
        {{title}}
        <span>{{subtitle}}</span>
      </p>
    <TransitionExpand>
      <div v-if="isOpen">
        <slot name="content" :contentData="contentData" :isOpen="isOpen"></slot>
      </div>
    </TransitionExpand>
  </div>
</template>
<script>
import TransitionExpand from '../transitions/TransitionExpand'
export default {
  name: 'Dropdown',
  data: function() {
    return {
      isOpen: this.initialIsOpen
    }
  },
  props: {
    title: String,
    subtitle: String,
    contentData: Object,
    initialIsOpen: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TransitionExpand
  }
}
</script>
<style>

</style>
